import appendQuery from 'append-query'
import { getResults } from '.'
import { CopilotCreateData, CopilotUpdateData, CopilotUploadPreset } from '../types/copilot'
import { DELETE, GET, POST, PUT } from '../util/fetch-methods'

const API_BASE_URL = '/api/v1/dvr-service'
const COPILOT_BASE_URL = '/ajax/copilot/presets/upload'
const COPILOT_SAVED_PRESET_BASE_URL = '/ajax/copilot/presets/upload/saved'

export type CopilotPresetApiResponse = {
    cursor: string
    upload_presets: CopilotUploadPreset[]
}

export const getVideoEmbedInfo = (url: string, withCaption: boolean = false) => {
    const requestUrl = appendQuery(`${API_BASE_URL}/video_info`, {
        url: encodeURIComponent(url),
        withCaption,
    })

    return getResults(requestUrl, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    })
}

export async function createCopilotPreset(data: CopilotCreateData): Promise<CopilotUploadPreset> {
    return getResults(COPILOT_BASE_URL, POST(data, true)).then(({ upload_preset }) => upload_preset)
}

export async function deleteCopilotPreset(id: string): Promise<Response> {
    return fetch(COPILOT_BASE_URL, DELETE({ preset_id: id }, true))
}

export async function fetchCopilotPresetsById(ids: string[]): Promise<CopilotUploadPreset[]> {
    return getResults(
        appendQuery(COPILOT_BASE_URL, {
            preset_ids: ids.join(','),
        }),
        GET
    ).then(({ upload_presets }) => upload_presets)
}

export async function fetchCopilotPresetsByAuthorId(id: string, cursor?: string): Promise<CopilotPresetApiResponse> {
    return getResults(
        appendQuery(COPILOT_BASE_URL, {
            author_id: id,
            cursor,
        }),
        GET
    ).then(({ cursor, upload_presets }) => ({
        cursor: cursor?.next || '',
        upload_presets,
    }))
}

export async function updateCopilotPreset(id: string, data: CopilotUpdateData): Promise<CopilotUploadPreset> {
    return getResults(COPILOT_BASE_URL, PUT({ ...data, preset_id: id }, true)).then(
        ({ upload_preset }) => upload_preset
    )
}

export async function fetchSavedCopilotPresets(cursor?: string): Promise<CopilotPresetApiResponse> {
    return getResults(
        appendQuery(COPILOT_SAVED_PRESET_BASE_URL, {
            cursor,
        }),
        GET
    ).then(({ cursor, upload_presets }) => ({
        cursor: cursor?.next || '',
        upload_presets,
    }))
}

export async function saveCopilotPreset(id: string): Promise<CopilotUploadPreset> {
    return getResults(COPILOT_SAVED_PRESET_BASE_URL, PUT({ preset_id: id }, true)).then(
        ({ upload_preset }) => upload_preset
    )
}

export async function removedSavedCopilotPreset(id: string): Promise<Response> {
    return fetch(COPILOT_SAVED_PRESET_BASE_URL, DELETE({ preset_id: id }, true))
}
